import { useEffect, useState } from "react";
import { getIntents } from "../../services/intents";

export default function useIntents() {
  const [isLoading, setIsLoading] = useState(true);
  const [intents, setIntents] = useState([]);

  const fetchData = async () => {
    const data = await getIntents();
    data && setIntents(data);
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    fetchData().catch(console.error);
  }, []);

  const reloadTable = async () => {
    setIsLoading(true);
    fetchData().catch(console.error);
  };

  return {
    isLoading,
    intents,
    reloadTable,
  };
}
